export default "__VITE_ASSET__8257ee5b__"